// BookingsContext.js
import React, { useState, useEffect } from 'react';
import { BreathAPIs } from '../../../APIs/BreathAPIs';

export const BookingsContext = React.createContext();

export const BookingsProvider = ({ children, initialDate, initUser }) => {
  const [bookingsData, setBookings] = useState(null);
  const [userBookings, setUserBookings] = useState(null);
  const [chargersData, setChargers] = useState([]);
  const [connectorData, setConnectorData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(initialDate);
  const [user, setUser] = useState(initUser);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const [isBookingLoading, setIsLoading] = useState(false);

  const [selectedPublicLocation, setSelectedPublicLocation] = useState(null);

  const [selectedLocationObj, setSelectedLocationObj] = useState(null);


  if (selectedLocation === null && user?.isGuest) {
    // Guests share one pool account across every login, so only restore a
    // previously-picked location if it was saved under this exact token -
    // a different login (even the same guest) starts with nothing pre-selected.
    const savedLocation = localStorage.getItem('selectedLocation');
    const savedLocationToken = localStorage.getItem('selectedLocationToken');
    const currentToken = localStorage.getItem('token');

    if (savedLocation && savedLocationToken && currentToken && savedLocationToken === currentToken) {
      setSelectedLocation(savedLocation);
    }
  }

  if (selectedLocation === null && !user?.isGuest) {

    const savedLocation = localStorage.getItem('selectedLocation');
    const nearByLocation = localStorage.getItem('nearByLocation');

    const isSavedLocationValid = user?.location?.some(location => location._id === savedLocation);

    const isSavedFavLocationValid = user?.favLocation?.some(favLocation => favLocation._id === savedLocation);

    const defaultLocation =  user?.defaultLocation;
    const isDefaultLocationValid = user?.location?.some(location => location._id === defaultLocation);
  
    if (isSavedLocationValid || isSavedFavLocationValid) {
      setSelectedLocation(savedLocation);
    }
    else if (nearByLocation) {
      setSelectedLocation(savedLocation);
    } 
    else if(savedLocation) {
      const firstLocation = savedLocation ? savedLocation : user?.location?.[0]?._id || '';
      setSelectedLocation(firstLocation);
    }
    else if(isDefaultLocationValid){
      setSelectedLocation(defaultLocation);
    }else{
      for (let loc of user?.location){
        if(loc?.subLocationType !== "CONDO"){
          setSelectedLocation(loc?._id)
        }
      }
      
    }

  }

  useEffect(() => {
    if(selectedPublicLocation !== null) setSelectedLocation(selectedPublicLocation._id );
  }, [selectedPublicLocation]);

  const refetchBookings = async () => {
    setIsLoading(true);

    try {
      const res = await BreathAPIs.getBookingList(selectedDate, selectedLocation);
      // console.log("Context chargers", res?.data?.chargers);
      setChargers(res?.data?.chargers);
      setBookings(res?.data?.bookings);
      setUserBookings(res?.data?.userBookings);
      setSelectedLocationObj(res?.data?.locationObj)
      let allConnectors = [];
      res?.data?.chargers?.forEach((charger) => {
        if (charger.connector && charger.connector.length > 0) {
          allConnectors.push(...charger.connector);
        }
      });
      setConnectorData(allConnectors);
      // console.log('allConnectors in context', allConnectors);
      setIsLoading(false);
    } catch (error) {
      if (error.response && error.response.status === 400) {
      } else {}
      
      setIsLoading(false);
    }
  };

  useEffect(()=>{
    if(selectedPublicLocation !== null) setSelectedLocation(selectedPublicLocation._id );
  }, selectedPublicLocation)
  
  useEffect(() => {
    refetchBookings();
  }, [selectedDate, selectedLocation]);


  const changeDate = (newDate) => {
    setSelectedDate(newDate);
  };

  const setUserContext = (userData) => {
    setUser(userData);
  };


  return (
    <BookingsContext.Provider value={{ bookingsData, userBookings, refetchBookings, chargersData, selectedDate, changeDate, selectedLocation, setSelectedLocation, user, setUserContext, isBookingLoading, selectedPublicLocation, setSelectedPublicLocation, selectedLocationObj, connectorData }}>
      {children}
    </BookingsContext.Provider>
  );
};
